import {Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TreatmentEndoToothGroupToothDataModel} from '../../models/treatment-endo-tooth-group-tooth-data.model';
import {TreatmentService} from '../../../../services/treatment.service';
import {TreatmentEndoDataModel} from '../../models/treatment-endo-data.model';
import {Globals} from '../../../../globals';
import {TreatmentEndoToothGroupDataModel, TreatmentEndoToothGroupDataTable, TreatmentEndoToothGroupModel} from '../../models/treatment-endo-tooth-group-data.model';
import {TdoTableRowModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {Observable, from, fromEvent, Subscription} from 'rxjs';
import {filter, groupBy, map, mergeMap, take, toArray} from 'rxjs/operators';
import {Constants} from '../../../../constants';
import {TemplatePortal} from '@angular/cdk/portal';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { parse } from 'path';
@Component({
    selector: 'app-treatment-teeth-group-dialog',
    templateUrl: './treatment-teeth-group-dialog.component.html',
    styleUrls: ['./treatment-teeth-group-dialog.component.scss']
})


export class TreatmentTeethGroupDialogComponent implements OnInit {
    @ViewChild('ledgerItemContextMenu') ledgerItemContextTemplate: TemplateRef<any>;
    isLoading = true;
    toothGroup: TreatmentEndoToothGroupDataModel[];
    toothGroupTable: TreatmentEndoToothGroupDataTable[] = [];
    treatmentModel: TreatmentEndoDataModel;
    saveGroup: TreatmentEndoToothGroupModel;
    saveToothInGroup: TreatmentEndoToothGroupToothDataModel;
    private overlayRef: OverlayRef | null;
    private sub: Subscription;
    selectedGroup: string;
    selectedGroupName: string = '';

    constructor(private dialogRef: MatDialogRef<TreatmentTeethGroupDialogComponent>,
                @Inject(MAT_DIALOG_DATA) private data: TreatmentEndoDataModel,
                private globals: Globals,
                private treatmentService: TreatmentService,
                private overlay: Overlay,
                private viewContainerRef: ViewContainerRef) {
        this.treatmentModel = data;
    }


    ngOnInit(): void {
    // get all teeth for caseWorkItemId
        this.treatmentService.getToothGroup(this.treatmentModel.CaseWorkItemTeeth[0].CaseWorkItemId, this.globals.currentPatientId).subscribe((res) => {
            this.toothGroupTable = res;
            this.toothGroup = this.toothGroupTable.filter(x => x.ToothGroupId !== null).map(x => ({ToothGroupID: x.ToothGroupId, Description: x.ToothGroupDescription, PatientId: x.patientId})).filter((value, index, self) => self.findIndex(t => t.ToothGroupID === value.ToothGroupID) === index);
            this.isLoading = false;
            // New Group
            if (this.toothGroup.length === 0)
                {
                    let newGroup = new TreatmentEndoToothGroupDataModel();
                    newGroup.PatientId = this.toothGroupTable[0].patientId;
                    newGroup.ToothGroupID = Constants.emptyGuid;
                    newGroup.Description = "A";
                    this.toothGroup.push(newGroup);
                }
            this.toothGroupTable.sort((a, b) => 
                new Date(a.DayOfVisit).getTime() - new Date(b.DayOfVisit).getTime()
              );
        });
    }

    getUniqueGroups(): { ToothGroupId: string; Description: string }[] {
        const uniqueGroups = new Map<string, string>();
        this.toothGroupTable.forEach(item => {
            if (!uniqueGroups.has(item.ToothGroupId)) {
                uniqueGroups.set(item.ToothGroupId, item.ToothGroupDescription);
            }
        });
        return Array.from(uniqueGroups.entries()).map(entry => ({ToothGroupId: entry[0], Description: entry[1]}));
    }


    async onOkClick() {
            await this.saveGroupTooth();
            this.dialogRef.close();
    }

    async saveGroupTooth() : Promise<void> {

        for (const group of this.getUniqueGroups()) {
            if (group.Description === '' || group.Description === null) {
                continue;
            }
            this.saveGroup = new TreatmentEndoToothGroupModel();
            this.saveGroup.ToothGroupID = group.ToothGroupId;
            this.saveGroup.Description = group.Description;
            this.saveGroup.PatientId = this.toothGroup[0].PatientId;
            this.saveGroup.dataTreatmentEndoToothGroupTeeth = [];
            if(group.ToothGroupId !== Constants.emptyGuid){
                    this.saveGroup.xauditCreatedBy = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditCreatedBy;
                    this.saveGroup.xauditCreatedOn = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditCreatedOn; 
                    this.saveGroup.xauditModifiedBy = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditModifiedBy;
                    this.saveGroup.xauditModifiedOn = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditModifiedOn;
                    this.saveGroup.xauditTableRowID = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditTableRowID;
                    this.saveGroup.xauditDeleted = this.toothGroupTable.find(x => x.ToothGroupId === group.ToothGroupId).xauditDeleted;
            }
            

            for (const toothByGroup of this.toothGroupTable.filter(x => x.ToothGroupId === group.ToothGroupId)) {
                    this.saveToothInGroup = new TreatmentEndoToothGroupToothDataModel();
                    this.saveToothInGroup.ToothGroupID = toothByGroup.ToothGroupId;
                    this.saveToothInGroup.ToothGroupToothID = toothByGroup.ToothGroupToothID;
                    this.saveToothInGroup.CaseWorkItemToothId = toothByGroup.CaseWorkItemToothId;
                    this.saveGroup.dataTreatmentEndoToothGroupTeeth.push(this.saveToothInGroup);
            }
            this.treatmentService.saveToothGroup(this.saveGroup).subscribe((saveRes) => {
            });
        }
        // delete unassigned groups
       const deleteGroups = this.toothGroup.filter(x => !this.toothGroupTable.some(y => y.ToothGroupId === x.ToothGroupID));
        for (const group of deleteGroups) {
            this.treatmentService.deleteToothGroup(group).subscribe((saveRes) => {
            });
        }

    }

    onCancelClick() {
        this.dialogRef.close();
    }

    getToothNum(row: TdoTableRowModel) {
        const model = this.treatmentModel.CaseWorkItemTeeth.find(p => p.CaseWorkItemToothId === row.model.CaseWorkItemToothId);
        if (model) {
            const toothModel = this.treatmentModel.cfgTeeth.find(p => p.ToothId === model.ToothID);
            if (toothModel) {
                return toothModel.cfgToothDescriptions[0].Notation;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    onRowContextMenu(event: TdoTableSelectionEvent) {
        this.openContext(event.mouseEvent, this.ledgerItemContextTemplate, event.model);
    }

    // Context boilerplate
    openContext({x, y}: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
      this.closeContext();
        x = x + 100;
        y = y - 10;
        const positionStrategy = this.overlay.position().flexibleConnectedTo({x, y}).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, {$implicit: data}));

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    closeContext(): void {
        this.sub !== undefined && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    selectGroup(data: TreatmentEndoToothGroupDataTable, indexGroup: number) {
        const newSelectGroup = this.toothGroupTable.find(x => x.CaseWorkItemToothId === data.CaseWorkItemToothId);
        if (newSelectGroup) {
            newSelectGroup.ToothGroupDescription = this.toothGroup[indexGroup].Description;
            newSelectGroup.ToothGroupId = this.toothGroup[indexGroup].ToothGroupID;
            newSelectGroup.ToothGroupToothID = Constants.emptyGuid;
        }
        if (this.selectedGroupName !== '') {
            this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupDescription === this.selectedGroupName? {...x, isInGroup: true} : x );
        }
        
    }

    removeFromGroup(data: TreatmentEndoToothGroupDataTable) {
        this.toothGroupTable = this.toothGroupTable.map(x => x.CaseWorkItemToothId === data.CaseWorkItemToothId? {...x, ToothGroupId: null, ToothGroupToothID: null, ToothGroupDescription : null}: x); ;
    }



    createNewGroup() {
        const newGroup: TreatmentEndoToothGroupDataModel = new TreatmentEndoToothGroupDataModel();
        newGroup.ToothGroupID = Constants.emptyGuid;
        newGroup.PatientId = this.toothGroup[0].PatientId;
        newGroup.Description = this.getNewGroupName();
        this.toothGroup.push(newGroup);
    }

    getNewGroupName() {
        const groupDescription = this.toothGroup.map(x => x.Description);
        const highestChar = groupDescription.reduce((prevChar, currentChar) =>
            prevChar.charCodeAt(0) > currentChar.charCodeAt(0) ? prevChar : currentChar
        );
        return String.fromCharCode(highestChar.charCodeAt(0) + 1);
    }

    onInGroupChange(event: MatCheckboxChange, row: TdoTableRowModel) {
        if (!event.checked) {

            this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupDescription === row.model.ToothGroupDescription ? {...x, isInGroup: event.checked} : x );
            this.selectedGroup = Constants.emptyGuid;
            this.selectedGroupName = '';
        } else if (row.model.ToothGroupId !== Constants.emptyGuid) 
        {
        this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupId === row.model.ToothGroupId ? {...x, isInGroup: event.checked} : x );
        this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupId !== row.model.ToothGroupId ? {...x, isInGroup: false} : x );
        this.selectedGroup = row.model.ToothGroupId;
        this.selectedGroupName = row.model.ToothGroupDescription
        }
        else {
            this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupDescription === row.model.ToothGroupDescription ? {...x, isInGroup: event.checked} : x );
            this.toothGroupTable = this.toothGroupTable.map(x => x.ToothGroupDescription !== row.model.ToothGroupDescription ? {...x, isInGroup: false} : x );
            this.selectedGroup = Constants.emptyGuid;
            this.selectedGroupName = row.model.ToothGroupDescription; 
        }
    }

    
}
